import { render, staticRenderFns } from "./GscSwitch.vue?vue&type=template&id=9b730d78"
import script from "./GscSwitch.vue?vue&type=script&lang=js"
export * from "./GscSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports